import apiClient from "./apiClient";
import { getDocumentBlobResponse, resolveSafeDocumentUrl } from "./documentDownload";

const ALLOWED_QUERY_PARAMS = [
  "source_module",
  "source_type",
  "storage_type",
  "parent_entity_type",
  "lifecycle_status",
  "search",
  "created_from",
  "created_to",
  "limit",
  "cursor",
  "offset",
];

const buildQueryParams = (params = {}) =>
  ALLOWED_QUERY_PARAMS.reduce((acc, key) => {
    const value = params?.[key];
    if (value === undefined || value === null || value === "") {
      return acc;
    }
    acc[key] = value;
    return acc;
  }, {});

export const getSupportingEvidence = async (params = {}) => {
  const response = await apiClient.get("/documents/supporting-evidence", {
    params: buildQueryParams(params),
  });
  return response.data;
};

export const resolveDocumentUrl = resolveSafeDocumentUrl;

const readBlobDetail = async (blob) => {
  if (!(blob instanceof Blob)) return "";
  try {
    const text = await blob.text();
    if (!text) return "";
    try {
      const parsed = JSON.parse(text);
      if (typeof parsed?.detail === "string") return parsed.detail;
      if (typeof parsed?.error === "string") return parsed.error;
      if (typeof parsed?.message === "string") return parsed.message;
    } catch (_err) {
      return text;
    }
    return text;
  } catch (_err) {
    return "";
  }
};

export const fetchAuthenticatedDocumentBlob = async (value) => {
  const response = await getDocumentBlobResponse(value);

  const status = Number(response?.status || 0);
  if (status < 200 || status >= 300) {
    const detail = await readBlobDetail(response?.data);
    if (detail) {
      throw new Error(`Preview unavailable (${status}): ${detail}`);
    }
    if (status === 403) {
      throw new Error("Preview unavailable (403): You no longer have access to this document.");
    }
    if (status === 404) {
      throw new Error("Preview unavailable (404): The stored file could not be found.");
    }
    throw new Error(`Preview unavailable (${status || "unknown"}).`);
  }

  return response?.data instanceof Blob
    ? response.data
    : new Blob([response?.data ?? new Uint8Array()], {
        type: response?.headers?.["content-type"] || "application/octet-stream",
      });
};
